import httpClient from '@/httpClient/httpClient';
import { TReportBuilderData } from './../helpers/reportBuilderHelpers';
import { ActionTree } from 'vuex';
import { GetterTree, MutationTree } from 'vuex';
import {
  ResponseBody,
  ResponseDataProvider,
  RootState,
  TDictionary,
} from '@/types/index';
import { IReportBuilderState } from '@/types/reports/reportBuilder';
import { getReportBuilderRequestData } from '@/helpers/reportBuilderHelpers';
import { ResponseDataProviderValue } from '@/utils/ResponseDataValue';

const state: IReportBuilderState = {
  reportBuilder: {
    rows: [],
    total: null,
    paginationData: null,
  },
};

const mutations: MutationTree<IReportBuilderState> = {
  setReportBuilder(state, reportBuilderData: TDictionary<any>) {
    if (!reportBuilderData.paginationData?.currentPage) {
      return;
    }
    state.reportBuilder.rows = reportBuilderData.data.rows;
    state.reportBuilder.total = reportBuilderData.data.total;
    state.reportBuilder.paginationData = reportBuilderData.paginationData;
  },
};

const getters: GetterTree<IReportBuilderState, RootState> = {
  getReportBuilderRows(state) {
    return state.reportBuilder.rows;
  },
  getReportBuilderTotal(state) {
    return state.reportBuilder.total;
  },
  getReportBuilderPaginationData(state) {
    return state.reportBuilder.paginationData;
  },
};

const actions: ActionTree<IReportBuilderState, RootState> = {
  async loadReportBuilder({ commit }, data: TReportBuilderData) {
    try {
      const requestParams: string = getReportBuilderRequestData(data);

      const response: ResponseBody = await httpClient().get(
        '/report-builder' + requestParams
      );
      const responseDataProvider: ResponseDataProvider =
        ResponseDataProviderValue(response, true);

      commit('setReportBuilder', responseDataProvider.data);
      return responseDataProvider;
    } catch (err) {
      console.error(err);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
